<style scoped>
    @import url("../../../styles/smartControl/faseExib.scss");
</style>

<template>
    <div class="box_faseExib">

        <div class="macro_el">
            <div class="tit ml-2">Fase selecionada</div>

            <div class="painelSearch">

                <v-btn 
                @click="back2phases()"
                class="mt-1 mb-1" 
                :style="{'width':'90px','font-size':'0.8rem'}">
                    <v-icon>mdi-arrow-left</v-icon>
                    <span>voltar</span>
                </v-btn>

                <div class="mainCard mt-1 mb-1">

                    <!-- linha 1 -->
                    <div class="elCard">
                        
                        <!-- coluna esquerda -->
                        <div class="tit">
                            <v-icon class="ml-1" color="#395872" size="32">mdi-receipt-text-edit-outline</v-icon>
                            <v-chip class="ml-1" color="white">{{ phase.phase_name }}</v-chip>
                            <v-chip class="ml-1" color="white"
                            :style="{'font-size':'0.7rem'}"
                            >{{ 'ID '+phase.phase_id }}</v-chip>
                        </div>

                        <!-- coluna direita -->
                        <div class="enable">

                            <div class="status">
                                <v-radio-group 
                                :style="{'height':'40px'}"
                                v-model="phase.status" inline
                                >
                                    <v-radio label="ON" value="on"></v-radio>
                                    <v-radio label="OFF" value="off"></v-radio>
                                </v-radio-group>
                            </div>

                            <div class="active" v-if="phase.status == 'on'">
                                <div>Estado:</div>
                                <span v-if="phase.active">Em operação</span>
                                <span v-else>Aguardando operação</span>
                            </div>

                            <div class="active" v-if="phase.status == 'on'">

                                <!-- FASE desabilitada -->
                                <v-icon v-if="phase.status == 'off'" 
                                size="32" 
                                color="gray"
                                >
                                    mdi-circle
                                </v-icon>

                                <!-- FASE ativa e aguardando -->
                                <v-icon v-else-if="phase.status == 'on' && phase.active == false" 
                                size="32" 
                                color="yellow"
                                >
                                    mdi-circle
                                </v-icon>

                                <!-- FASE ativa e em operação -->
                                <v-icon v-else-if="phase.status == 'on' && phase.active == true" 
                                size="32" 
                                color="green"
                                >
                                    mdi-circle
                                </v-icon>

                                <!-- estado não previsto -->
                                <v-icon v-else
                                size="32" 
                                color="red"
                                >
                                    mdi-circle
                                </v-icon>
                            </div>

                        </div>
                    </div>

                    <!-- linha 2 -->
                    <FormDate v-if="phase.status == 'on'" 
                    :phase="phase"
                    @fromFormDate="alocDate($event)"
                    />

                    <!-- linha 3 -->
                    <div class="tit_cycles ml-2" v-if="phase.status == 'on'" >
                        <v-icon>mdi-rotate-360</v-icon>
                        <div class="ml-1" :style="{'color':'#395872'}">Ciclos da fase</div>
                    </div>

                    <!-- linha 4 (VIEW) -->
                    <div class="painel_cycles" v-if="phase.status == 'on' && !flagFormAgend" >
                        <CycleFase
                        v-for="(cycle,j) in phase.cycles" :key="j"
                        :cycle="cycle"
                        :cycleIndex="j"
                        class="mt-1" 
                        @doc2edit="doc2edit = $event"
                        @flagBoolOpenFormAgend="flagFormAgend = $event"
                        @infoCycleEdited="positionCycle($event)"
                        />
                    </div>

                    <!-- linha 4 (EDIÇÃO) -->
                    <div class="painel_cycles" v-if="phase.status == 'on' && flagFormAgend" >
                        <FormAct 
                        class="mt-1" 
                        :agent_unit="agent_unit"
                        :doc2edit="doc2edit"
                        @flagBoolCloseFormAgend="flagFormAgend = $event"
                        @infoDocEdited="positionDoc($event)"
                        />
                        <!-- @flagBoolChangeDoc="flagChanged = $event" -->
                    </div>
                </div>

                <!-- btn atualização -->
                <v-btn v-if="flagChanged"
                @click="upPhases()"
                class="mt-2"
                block 
                :style="{'background':'#f39c12','color':'white','white-space':'normal !important'}"
                >atualizar</v-btn>

            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

//import convFromUtc from '../auxSC/timeConv.js'
//import { convFromUtc } from "../auxSC/timeConv.js";

import FormDate from './FormDate'
import CycleFase from './CycleFase'
import FormAct from './FormAct'

export default {

    props:['agent_unit','idPhase'],

    components:{FormDate,CycleFase,FormAct},

    data() {
        return {

            //
            phase_snapshot:{},
            phase:{},
            flagChanged:false,

            // edit act agend from cycle
            flagFormAgend:false,
            doc2edit:{},
        }
    },

    watch: {
        phase: {
            deep: true,
            handler() {
                this.watchChange(); // call func in local methods
            }
        }
    },

    methods:{

        positionDoc(dictInfoDoc) {
            const docAct = dictInfoDoc.formFinal
            const docIndex = dictInfoDoc.indexListAct
            const liName = this.doc2edit.srcStr
            const cycleIndex = this.doc2edit.indexCycle
            //console.log('idPhase: ',this.idPhase) // from props
            //console.log('idCycle: ',cycleIndex) // from CycleFase.vue
            //console.log('docID: ',docIndex) // from FormAct.vue
            //console.log('liName: ',liName)

            // -- sobrepor doc editado. (edição main dispara flag changed)
            //this.phase.cycles[cycleIndex].li_transition_entry[docIndex] = docAct
            this.phase.cycles[cycleIndex][liName][docIndex] = docAct;
        },

        positionCycle(dictInfoCycleEdited) {

            const docCycle = dictInfoCycleEdited.cycleFinal;
            const cycleIndex = dictInfoCycleEdited.indexCycle;

            this.phase.cycles[cycleIndex] = docCycle; // sobrepor vai disparar a flagChange local aqui
        },

        async upPhases() {

            //this.$emit('flagLoadingFather', true) // habilitar loading geral
            // ----> esse emit true encerra o componente implica que os prox emit nao existirao

            //console.log('[upPhases] this.phase: ',this.phase)

            const sistema = this.$store.state.sistemaSC
            const cl = this.$store.state.emailCliente

            const params = {
                cliente: cl,
                sistema: sistema,
                phase_id: this.idPhase, // via props
                phase:this.phase // montado em positionDoc()
            }

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            const url = this.$store.state.pathAxiosBASE + '/upxphasex'
            const res = await axios.post(url, params, {headers})

            //console.log('[upPhases][res]', res.data)

            const result = res?.data?.result ?? res?.data

            let flagString = ''
            if (result == 'up-ok') { 
                //console.log('[upPhases] ok')
                flagString = 'Atualizado.' 
            }
            else { 
                //console.log('[upPhases] failed') 
                flagString = 'Não foi possível atualizar. Tente novamente mais tarde.'
            }
            
            //this.$emit('flagLoadingFather', false) // desabilitar loading geral
            // ----> o 1o emit sob true encerra o componente entao esse emit false nunca acontece

            window.scrollTo(0,0)

            this.$emit('msg2Dialog', flagString) // dialog control
            this.$emit('openDialog', true) // abrir dialog com resultado do update
        },

        alocDate(dictPart) {
            this.phase['utc_phase_init'] = dictPart['utc_phase_init']
            this.phase['utc_phase_end'] = dictPart['utc_phase_end']
        },

        //concatKeyInDict(dictPart) { Object.assign(this.phase, dictPart); },

        back2phases() { this.$emit('flagBoolClosePhase', false) },

        watchChange() { this.flagChanged = JSON.stringify(this.phase) !== JSON.stringify(this.phase_snapshot); },

        initExibPhase() {
            const phaseSource = this.agent_unit["phases"][this.idPhase]
            this.phase_snapshot = structuredClone(phaseSource); // depth copy
            this.phase = structuredClone(phaseSource); // depth copy
        },
    },

    created() {
        //window.scrollTo(0,0)
        //const phaseLocal = structuredClone(this.agent_unit["phases"][this.idPhase]); // depth copy
        //this.prepareToExib(phaseLocal) // rcv via props and selected by id list phases

        this.initExibPhase()
    }
}
</script>